import { TRootState }    from 'Redux/Reducers';
import { checkUserRole } from '../CheckUserRole/CheckUserRole';
import * as ROLES        from 'Config/SystemRoles';

export const isAdmin = (state: TRootState) => {
  return checkUserRole([ ROLES.SYSTEM_ADMIN.key ])(state);
};
